import { readShigoAppConfig } from '../../lib/config';
import { useShigoSession } from '../../lib/useShigoSession';
import { createDemandClient } from './demandApi';

export const agencyDemandQueryKey = (networkId: string, agencyId: string) =>
  ['agency-demand', networkId, agencyId] as const;
export function useDemandClient(agencyId?: string) {
  const config = readShigoAppConfig();
  const { session } = useShigoSession();
  return createDemandClient({
    config: { apiBaseUrl: config.apiBaseUrl, networkId: config.networkId },
    accessToken: session?.accessToken ?? '',
    ...(agencyId ? { agencyId } : {}),
  });
}
